<template>
  <div class="container small">
    <line-chart v-if="loaded" :chart-data="chartdata" :chart-options="options" />
  </div>
</template>

<script>
import LineChart from "../components/LineChart";
import axios from "axios";
export default {
  name: "History",
  components: {
    LineChart
  },
  mounted() {
    this.loaded = false;
    let id = this.$route.query.id
    axios.get("https://api.poe.watch/history?id=" + id).then(response => {
      this.labels = response.data.map(item => item.created_at);
      let means = response.data.map(item => item.mean);
      this.options = {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              }
            }
          ]
        },
        responsive: true,
        maintainAspectRatio: false
      };

      this.chartdata = {
        labels: this.labels,
        datasets: [
          {
            label: "Item",
            borderWidth: 1,
            fill: false,
            data: means,
            borderColor: "#2554FF",
            backgroundColor: "#2554FF"
          }
        ]
      };
      this.loaded = true;
    });
  },
  data() {
    return {
      loaded: false,
      chartdata: null
    };
  }
};
</script>

<style>
.small{
    max-width: 800px;
}
</style>